<template>
  <div
    class="clamp-py-2-3 clamp-px-2-3 bg-white color-[--active-color] clamp-rounded-1-2 clamp-max-w-48-56 w-screen"
    :class="[
      'flex flex-col justify-center items-center text-center clamp-gap-1-1',
      {
        'arrow-right': arrowPosition === 'right',
        'arrow-left': arrowPosition === 'left',
        'arrow-top': arrowPosition === 'top',
        'arrow-bottom': arrowPosition === 'bottom',
      },
    ]"
    :style="{
      '--active-color': primaryColor?.hex || 'black',
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import useConfig from '@/composables/useConfig';

const { primaryColor } = useConfig();

interface Props {
  arrowPosition?: 'right' | 'left' | 'top' | 'bottom';
}
withDefaults(defineProps<Props>(), {
  arrowPosition: 'right',
});
</script>

<style scoped lang="scss">
.arrow-left,
.arrow-right,
.arrow-top,
.arrow-bottom {
  &::after {
    @apply content-[''] absolute border-solid clamp-border-2-3 border-transparent;
  }
}
.arrow-left {
  &::after {
    @apply top-50% right-100% translate-y-[-50%] translate-x-[3px];
    border-right-color: white;
  }
}
.arrow-right {
  &::after {
    @apply top-50% left-100% translate-y-[-50%] translate-x-[-3px];
    border-left-color: white;
  }
}
.arrow-top {
  &::after {
    @apply bottom-100% left-50% translate-x-[-50%] translate-y-[3px];
    border-bottom-color: white;
  }
}
.arrow-bottom {
  &::after {
    @apply top-100% left-50% translate-x-[-50%] translate-y-[-3px];
    border-top-color: white;
  }
}
</style>
